export interface HeatScore {
  id: number;
  name: string;
  description: string;
}

export const HEAT_SCORES: HeatScore[] = [
  { 
    id: 1, 
    name: "Declining", 
    description: "ripe for reinvention" 
  },
  { 
    id: 2, 
    name: "Flat", 
    description: "plateauing but still holding" 
  },
  { 
    id: 3, 
    name: "Gaining slow", 
    description: "established trends" 
  },
  { 
    id: 4, 
    name: "Gaining fast", 
    description: "trendy, emerging items" 
  },
  { 
    id: 5, 
    name: "On fire!", 
    description: "the trendiest foods" 
  },
];

export const HEAT_SCORES_SORTED: HeatScore[] = [...HEAT_SCORES].sort((a, b) => b.id - a.id);

export const HEAT_SCORE_DESCRIPTION = (
    <>The <strong>HEAT SCORE</strong> measures growth in consumer familiarity with that item. It is both the absolute point increase and relative growth rate of each item's "know it" score</>
);